/**
 * Contenu pédagogique : types, formats, statuts et provenance.
 *
 * Invariant (cf. ADR-0005) : contenu servi = validé. Soit `publie` (banque revue
 * par un humain), soit issu d'un générateur validé passant l'intégralité des
 * garde-fous automatisés. Tenter de servir un item non publié => 403.
 */
/** Cycle de vie d'un `ContentItem`. */
export const CONTENT_STATUSES = [
    'brouillon_IA',
    'en_revue',
    'valide',
    'publie',
    'rejete',
    /**
     * Sprint 24 — item SORTI du service après une correction de FOND. Il n'est
     * plus servable, mais il reste lisible : les observations qu'il a produites
     * pointent toujours vers le texte exact qui les a produites. On ne supprime
     * pas un item sous une mesure.
     */
    'retire',
];
/** Type de tâche porté par un `ContentItem`. */
export const CONTENT_TYPES = [
    'qcm',
    'reponse_numerique',
    'reponse_courte',
    'appariement',
    'texte_a_trous',
    'ordonnancement',
    'redaction',
    'demonstration',
    'comprehension_lecture',
];
/** Support d'exécution attendu pour la tâche. */
export const CONTENT_FORMATS = ['interactif', 'imprimable', 'canevas_stylet'];
/** D'où vient la tâche présentée à l'élève. */
export const TASK_ORIGINS = ['banque', 'generation', 'tuteur'];
/**
 * Provenance affichée à l'élève et au parent (cf. ADR-0005).
 * `valide_par_pedagogue` = banque revue ; `genere_pour_toi` = génération à la demande.
 */
export const CONTENT_PROVENANCE = [
    'valide_par_pedagogue',
    'genere_pour_toi',
    'ajout_tuteur',
];
/** Modes de travail d'une session. */
export const WORK_MODES = ['in_app', 'papier', 'photo'];
/**
 * Sortie de `POST /v1/exercices/transcription`.
 *
 * `texte === null` n'est PAS une erreur : c'est « on n'a pas su lire », une
 * dégradation gracieuse (FR-4.9) que le client présente sans dramatiser et qui
 * laisse l'élève redessiner ou changer de mode de saisie. AUCUN verdict n'est
 * rendu ici : cette étape LIT, elle ne juge pas.
 */
/**
 * Les deux voies de lecture d'une écriture mathématique.
 *
 * Choisi PAR REQUÊTE, et temporairement offert à l'élève dans l'écran de
 * transcription : la décision entre les deux se prendra sur des tests en
 * conditions réelles, et pour ça il faut pouvoir basculer sans redéployer.
 *
 * `vision` est le fournisseur généraliste (le chemin historique). `mathpix`
 * est le fournisseur spécialisé en notation mathématique.
 */
export const FOURNISSEURS_TRANSCRIPTION = ['vision', 'mathpix'];
/** Verdicts possibles rendus à l'élève après soumission. */
export const VERDICTS_EXERCICE = ['juste', 'faux', 'indeterminé'];
//# sourceMappingURL=content.js.map